'use strict';

angular.module('atex.dam').controller('DamLeftSideController', ['$scope', 'UserProfileService','configuration', function($scope, UserProfileService, configuration) {

  $scope.oneAtATime = true;

  $scope.foldersOpen = false;
  $scope.treeLevelOpen = false;

  $scope.showScheduling = false;
  $scope.schedulingOpen = false;
  $scope.showWebSectionsWidget = false;

  function capitalize(s)
  {
    return s && s[0].toUpperCase() + s.slice(1);
  }

  function canShow( panel ) {
    var action = panel + '-panel';
    var showPanel = 'show' + capitalize( panel );

    $scope[showPanel] = false;

    return UserProfileService.disableAction({'action': action, 'application': 'desk'}).then(function (disable) {
      if (!disable) {
        var showPanel = 'show' + capitalize( panel );
        $scope[showPanel] = true;
      }
    });

  }

  function canShowCollections() {
    return UserProfileService.disableAction({'action': 'collections-panel', 'application': 'desk'}).then(function (disable) {
      if (!disable) {
        $scope.showCollections = true;
      }
    });
  }

  function canShowPublishingSchedule() {
    configuration.getPublishingScheduleEnabled().then(function (value) {
      $scope.showScheduling = value;
    });
  }

  function initialise() {
    $scope.facetOpen = false;
    $scope.queryListOpen = false;
    $scope.drawerOpen = false;
    $scope.collectionsOpen = false;
    $scope.publicationsOpen = false;
    $scope.queuesOpen = false;
    $scope.showPublications = true;
    $scope.schedulingOpen = false;
    $scope.treeLevelOpen = false;

    canShow( 'collections' );
    canShow( 'collect' );
    canShow( 'facets' );
    canShow( 'folders' );
    canShow( 'queries' );
    canShow( 'queues' );
    canShow( 'scheduling' );
    canShow( 'sections' );

    configuration.whenReady().then(function() {
      var config = configuration.getWebSectionWidget();
      $scope.showWebSectionsWidget = config.enabled;
    });
  }

  $scope.$on("onecms:authenticationSuccess", function() {
    initialise();
  });

  $scope.$on('dam:collectionCreated', function(event) {
    $scope.collectionsOpen = true;
  });

  $scope.$on("dam:collectionRetrieved", function(event, collection) {
    $scope.drawerOpen = true;
  });
  
  $scope.$on("dam:addItemToCollector", function(event, collection) {
    $scope.drawerOpen = true;
  });

  $scope.$on("dam:openCollectionList", function(event) {
    $scope.collectionsOpen = true;
  });
  
  $scope.$on("dam:openQueryList", function(event) {
    $scope.queryListOpen = true;
  });

  $scope.$on("dam:openScheduleList", function(event) {
    $scope.schedulingOpen = true;
  });

  $scope.setPushPin = function(panel) {
    $scope.oneAtATime = false;
    if (this.icon === 'fa fa-thumb-tack close icon-size') {
      this.icon = 'fa fa-check close icon-size';
      $scope[panel] = true;
    } else {
      this.icon = 'fa fa-thumb-tack close icon-size';
      $scope[panel] = !($scope.facetOpen || $scope.queryListOpen || $scope.drawerOpen);
    }
  };

  $scope.handleLeftSideDragOver = function(e) {
    if ($scope.drawerOpen === false) {
      $scope.drawerOpen = true;
      $scope.$digest();
      e.originalEvent.dataTransfer.dropEffect = 'none';
      e.preventDefault();
      return false;
    }
  };

  $scope.handleFoldersHeadingDragOver = function(e) {
    if ($scope.foldersOpen === false) {
      $scope.foldersOpen = true;
      $scope.$digest();
      e.originalEvent.dataTransfer.dropEffect = 'none';
      e.preventDefault();
      return false;
    }
  };

  $scope.handleDrawerDragOver = function(e) {
    e.originalEvent.dataTransfer.dropEffect = 'link';
    e.preventDefault();
    return false;
  };

  $scope.$watch('queryListOpen', function (newValue, oldValue) {
    if (newValue !== undefined && oldValue !== undefined) {
      $scope.$root.$broadcast("dam:toggleQueryList", newValue);
    }
  });

  initialise();
}]);
